import React from 'react'

import { icons } from '@/constants/icons'

import { HeaderLogo, HomeTabPageHeaderLayout } from '../styles'

type Props = {
  isHidden: boolean
  children: React.ReactNode
  focusIdPrefix?: string
}

export const HomeTabPageHeader = ({
  children,
  isHidden,
  focusIdPrefix = '',
}: Props) => {
  return (
    <HomeTabPageHeaderLayout
      focusId={`${focusIdPrefix}_homeTabPageHeader`}
      $isHidden={isHidden}
    >
      {children}
      <HeaderLogo
        src={icons.logoApp.logoWhite}
        alt="logo"
        className="header-logo"
      />
    </HomeTabPageHeaderLayout>
  )
}
